import {
  drawerWidth,
  transition,
  container
} from "assets/jss/material-dashboard-react.jsx";

const appStyle = theme => ({
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh"
  },
  mainPanel: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch"
  },
  mainPanelFullWidth: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - 73px)`
    },
   
  },
  content: {
    
      marginTop: "5px",
      padding: "0px 12px",
    [theme.breakpoints.down('md')]: {

      marginTop: "0px",
      padding: "0px 1px 10px 1px",
    },
    minHeight: "calc(100vh - 123px)"
  },
  
  container: {
    ...container,
    [theme.breakpoints.down('md')]: {

      paddingRight: "1px",
      paddingLeft: "1px",
    },
  },
  map: {
    marginTop: "70px"
  }
});

export default appStyle;
